import * as React from 'react';

import { Box } from '~shared/components/Box';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconExclamationTriangleSvg } from './IconExclamationTriangleSvg';

export type IconExclamationTriangleProps = UseIconProps;

export function IconExclamationTriangle(props: IconExclamationTriangleProps) {
  const iconProps = useIcon({ size: 'large', ...props });

  return <Box tagName={IconExclamationTriangleSvg} {...iconProps} />;
}
